import React, { useState } from 'react';
import { HiMiniSlash } from "react-icons/hi2";
import axios from 'axios';
import Navbar from '../home/Navbar';
import { useNavigate } from 'react-router';
import natalchart from "../assets/rootimg/natalchart.png";
import natalsecond from "../assets/rootimg/natal2.png";
import natalthird from "../assets/rootimg/natal3.png";
import Queryform from './Queryform';
import Footer from '../home/Footer';
import { API_END_POINT } from './Utils/Constant';

const NatalChart = () => {
    const [formData, setFormData] = useState({
        name: "",
        birthPlace: "",
        month: "",
        day: "",
        year: "",
        hour: "",
        minute: "",
        second: "0",
        ampm: "AM",
        latitude: "",
        longitude: "",
        timezone: 5.5
    });

    const [errors, setErrors] = useState({});
    const [suggestions, setSuggestions] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const years = Array.from({ length: 120 }, (_, i) => new Date().getFullYear() - i);
    const hours = Array.from({ length: 12 }, (_, i) => i + 1);
    const minutes = Array.from({ length: 60 }, (_, i) => (i < 10 ? `0${i}` : i));

    const handlePlaceSearch = async (e) => {
        const query = e.target.value;
        if (query.length < 3) {
            setSuggestions([]);
            return;
        }

        try {
            const response = await axios.get(`${API_END_POINT}data/places/suggestions?city=${query}`);
            if (response.data) {
                setSuggestions(response.data);
            }
        } catch (error) {
            console.error('Error fetching place suggestions:', error);
            setSuggestions([]);
        }
    };

    const handleSuggestionSelect = (suggestion) => {
        setFormData((prevData) => ({
            ...prevData,
            birthPlace: suggestion.place_name,
            latitude: suggestion.latitude,
            longitude: suggestion.longitude,
        }));
        setSuggestions([]);
        setSelectedIndex(null);
    };

    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.min(suggestions.length - 1, prevIndex + 1)));
            e.preventDefault();
        } else if (e.key === "ArrowUp") {
            setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.max(0, prevIndex - 1)));
            e.preventDefault();
        } else if (e.key === "Enter" && selectedIndex !== null) {
            handleSuggestionSelect(suggestions[selectedIndex]);
            e.preventDefault();
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.name.trim()) newErrors.name = "Name is required";
        if (!formData.birthPlace.trim()) newErrors.birthPlace = "Birth place is required";
        if (!formData.month || !formData.day || !formData.year) newErrors.dob = "Date of birth is required";
        if (!formData.hour || !formData.minute) newErrors.time = "Time of birth is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            try {
                const { month, day, year, hour, minute, ampm, latitude, longitude, timezone } = formData;

                // Convert hour to 24-hour format
                let hourIn24Format = parseInt(hour);
                if (ampm === "PM" && hourIn24Format < 12) {
                    hourIn24Format += 12; // Convert PM hour to 24-hour format
                } else if (ampm === "AM" && hourIn24Format === 12) {
                    hourIn24Format = 0; // Convert 12 AM to 0 hours
                }

                // Prepare request data for planets API
                const requestData1 = {
                    year: parseInt(year),
                    month: parseInt(month),
                    date: parseInt(day),
                    hours: hourIn24Format,
                    minutes: parseInt(minute),
                    seconds: 0,
                    latitude: parseFloat(latitude),
                    longitude: parseFloat(longitude),
                    timezone: parseFloat(timezone),
                    config: {
                        observation_point: "topocentric",
                        ayanamsha: "tropical",
                        language: "en"
                    }
                };

                // Prepare request data for houses API
                const requestData2 = {
                    year: parseInt(year),
                    month: parseInt(month),
                    date: parseInt(day),
                    hours: hourIn24Format,
                    minutes: parseInt(minute),
                    seconds: 0,
                    latitude: parseFloat(latitude),
                    longitude: parseFloat(longitude),
                    timezone: parseFloat(timezone),
                    config: {
                        observation_point: "topocentric",
                        ayanamsha: "tropical",
                        house_system: "Placidus",
                        language: "en"
                    }
                };

                // Prepare request data for natal chart API
                const requestData3 = {
                    year: parseInt(year),
                    month: parseInt(month),
                    date: parseInt(day),
                    hours: hourIn24Format,
                    minutes: parseInt(minute),
                    seconds: 0,
                    latitude: parseFloat(latitude),
                    longitude: parseFloat(longitude),
                    timezone: parseFloat(timezone),
                    config: {
                        observation_point: "topocentric",
                        ayanamsha: "tropical",
                        house_system: "Placidus",
                        language: "en",
                        exclude_planets: [
                            "Lilith", "IC", "MC", "Chiron"
                        ]
                    }
                };

                const API_KEY = import.meta.env.VITE_FREEASTROAPI_KEY;

                // Call the planets API
                const response1 = await axios.post(`${API_END_POINT}western/planets`, requestData1, {
                    headers: { 'x-api-key': API_KEY }
                });

                // Call the houses API
                const response2 = await axios.post(`${API_END_POINT}western/housesdata`, requestData2, {
                    headers: { 'x-api-key': API_KEY }
                });

                // Call the natal chart API
                const response3 = await axios.post(`${API_END_POINT}western/natalchart`, requestData3, {
                    headers: { 'x-api-key': API_KEY }
                });

                // Check if the responses are successful and include the image URL
                if (response1.data.success && response2.data.success && response3.data.success) {
                    navigate('/natalchart/result', {
                        state: {
                            data: {
                                planetsData: response1.data.data,
                                housesData: response2.data.data,
                                chartImage: response3.data.data.output // Correctly access the image URL here
                            }
                        }
                    });
                    // console.log("Form Submitted:", formData);
                    // console.log("Response data of image:", response3.data); // Log the response for debugging
                }
            } catch (error) {
                console.error("Error submitting form:", error.response ? error.response.data : error.message);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <section className="min-h-screen bg-gradient-to-r from-white to-success/40 text-gray-900">
            <Navbar />
            <div className="text-center py-10">
                <h1 className="text-4xl p-2 font-serif font-bold text-secondary">Unlock Your Astrology Birth Chart</h1>
                <p className="text-gray-700 p-2 max-w-2xl mx-auto mt-3">
                    Generate your free, personalized, and fully customizable birth (natal) chart by completing the form below.
                </p>
            </div>
            <div className="flex flex-col md:flex-row items-center justify-center gap-12 px-6">
                {/* Image Section */}
                <div className="w-full max-w-sm">
                    <img src={natalchart} alt="Natal Chart" className="w-full object-contain" />
                </div>
                <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-lg">
                    <h2 className="text-lg font-semibold text-secondary uppercase mb-4">Fill in your details</h2>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <label className="block text-gray-900">
                            My name is:
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full border-b border-gray-400 focus:border-black outline-none bg-transparent mt-1 p-2"
                                placeholder="Enter your name"
                            />
                            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
                        </label>

                        <label className="block text-gray-900">
                            I was born in:
                            <input
                                type="text"
                                name="birthPlace"
                                value={formData.birthPlace}
                                onChange={handleChange}
                                onInput={handlePlaceSearch}
                                onKeyDown={handleKeyDown}
                                className="w-full border-b border-gray-400 focus:border-black outline-none bg-transparent mt-1 p-2"
                                placeholder="City, state, country"
                            />
                            {errors.birthPlace && <p className="text-red-500 text-sm">{errors.birthPlace}</p>}
                        </label>

                        {suggestions.length > 0 && (
                            <div className="bg-white border border-gray-300 rounded-md mt-2 max-h-60 overflow-y-auto">
                                {suggestions.map((suggestion, index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleSuggestionSelect(suggestion)}
                                        className={`cursor-pointer p-2 hover:bg-gray-200 ${selectedIndex === index ? "bg-gray-300" : ""}`}
                                    >
                                        {suggestion.place_name}
                                    </div>
                                ))}
                            </div>
                        )}

                        <label className="block text-gray-900">
                            My date of birth is:
                            <div className="flex items-center gap-3 mt-1">
                                <select name="month" value={formData.month} onChange={handleChange} className="w-1/3 border border-gray-400 rounded-lg focus:border-black outline-none bg-white p-2">
                                    <option value="">MM</option>
                                    {months.map((month, index) => (
                                        <option key={index} value={month}>{month}</option>
                                    ))}
                                </select>
                                <HiMiniSlash className="text-gray-500 text-xl" />
                                <select name="day" value={formData.day} onChange={handleChange} className="w-1/4 border border-gray-400 rounded-lg focus:border-black outline-none bg-white p-2">
                                    <option value="">DD</option>
                                    {days.map((day) => (
                                        <option key={day} value={day}>{day}</option>
                                    ))}
                                </select>
                                <HiMiniSlash className="text-gray-500 text-xl" />
                                <select name="year" value={formData.year} onChange={handleChange} className="w-1/3 border border-gray-400 rounded-lg focus:border-black outline-none bg-white p-2">
                                    <option value="">YYYY</option>
                                    {years.map((year) => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                            {errors.dob && <p className="text-red-500 text-sm">{errors.dob}</p>}
                        </label>

                        <label className="block text-gray-900">
                            Time of birth:
                            <div className="flex items-center gap-3 mt-1">
                                <select name="hour" value={formData.hour} onChange={handleChange} className="w-1/4 border border-gray-400 rounded-lg focus:border-black outline-none bg-white p-2">
                                    <option value="">hh</option>
                                    {hours.map((hour) => (
                                        <option key={hour} value={hour}>{hour}</option>
                                    ))}
                                </select>
                                <span className="text-lg">:</span>
                                <select name="minute" value={formData.minute} onChange={handleChange} className="w-1/4 border border-gray-400 rounded-lg focus:border-black outline-none bg-white p-2">
                                    <option value="">mm</option>
                                    {minutes.map((minute) => (
                                        <option key={minute} value={minute}>{minute}</option>
                                    ))}
                                </select>

                                <select name="ampm" value={formData.ampm} onChange={handleChange} className="w-1/4 border border-gray-400 rounded-lg focus:border-black outline-none bg-white p-2">
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                </select>
                            </div>
                            {errors.time && <p className="text-red-500 text-sm">{errors.time}</p>}
                        </label>

                        <button
                            type="submit"
                            className={`bg-gray-900 text-white w-full py-2 rounded-md font-semibold hover:bg-secondary transition duration-300 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={loading} // Disable button when loading
                        >
                            {loading ? 'Creating Chart...' : 'CREATE CHART'} {/* Change button text based on loading state */}
                        </button>
                    </form>
                </div>

            </div>
            {/* Main sections div */}
            <main className=" text-gray-900 py-16">
                <div className="container mx-auto max-w-6xl flex flex-col lg:flex-row items-center justify-between px-6 lg:px-12">

                    {/* Right: Content */}
                    <div className="lg:w-1/2">
                        <h2 className="text-3xl font-bold font-serif text-gray-900 mb-4">What is a Birth Chart?</h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Your Birth Chart, also known as the Natal Chart, is like a snapshot of the sky
                            the moment you were born, capturing a unique arrangement of planets and stars
                            that shape your personality, strengths, potential, and life path. It goes beyond
                            your sun sign, offering a deeper look at how different aspects of the heavens interact.
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-6">
                            Think of your birth chart as a code filled with symbols that reveal your talents,
                            potential challenges, and the path your life may take. Exploring your birth chart
                            is a journey of self-discovery, helping you uncover your strengths and navigate
                            the possibilities ahead.
                        </p>
                    </div>

                    {/* Left: Image for What is a Birth Chart */}
                    <div className="lg:w-1/2 flex justify-center">
                        <img src={natalsecond} alt="Natal Chart" className="w-full max-w-md object-contain" />
                    </div>
                </div>
                {/* Second Section */}
                <div className="container mx-auto max-w-6xl flex flex-col-reverse lg:flex-row items-center justify-between px-6 lg:px-12 mt-10 rounded-lg">

                    {/* Right: Image */}
                    <div className="lg:w-1/2 flex justify-center">
                        <img src={natalthird} alt="Understanding Birth Chart" className="w-full max-w-md object-contain" />
                    </div>
                    {/* Left: Content */}
                    <div className="lg:w-1/2">
                        <h2 className="text-3xl font-bold font-serif text-gray-900 mb-4">Importance of Understanding Your Birth Chart</h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            A birth chart is more than an astrological profile; it's a comprehensive tool for self-understanding.
                            It helps you see your strengths and areas for growth, enhances self-awareness, and supports better
                            decision-making in life. Knowing your birth chart can improve how you relate to others
                            and help you identify the best approaches to achieve your goals.
                        </p>
                    </div>
                </div>
            </main>
            <div className="bg-gray-100 text-gray-900 py-6">
                <div className="container mx-auto max-w-5xl text-center px-6">

                    {/* Title */}
                    <h2 className="text-4xl font-bold font-serif text-gray-900 mt-4 mb-4">
                        What Can You See in Your Birth Chart?
                    </h2>

                    {/* Subtitle */}
                    <p className="text-gray-700 leading-relaxed mb-8">
                        Your birth chart is a unique map of your personality, potential, and life path. It's made up of four key
                        components that create a dynamic portrait of who you are, what motivates you, where you excel, and where
                        you may face challenges.
                    </p>
                    {/* Grid Layout */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        {/* Card 1 - Planets */}
                        <div className="bg-white p-6 shadow-md rounded-lg flex items-start gap-4 border-l-4 border-purple-500">

                            <div>
                                <h3 className="text-lg font-semibold text-purple-500">Planets in your birth chart</h3>
                                <p className="text-gray-700 text-sm mt-2">
                                    These represent your core drives and energies. Each planet symbolizes a different aspect of
                                    your psyche and life experience, from your identity and emotions to your ambition and growth.
                                </p>
                            </div>
                        </div>

                        {/* Card 2 - Signs */}
                        <div className="bg-white p-6 shadow-md rounded-lg flex items-start gap-4 border-l-4 border-indigo-500">

                            <div>
                                <h3 className="text-lg font-semibold text-indigo-500">Signs in your birth chart</h3>
                                <p className="text-gray-700 text-sm mt-2">
                                    The zodiac signs show the style and quality of expression for each planet. They reveal how
                                    you embody and express the planetary energies in your unique way.
                                </p>
                            </div>
                        </div>

                        {/* Card 3 - Houses */}
                        <div className="bg-white p-6 shadow-md rounded-lg flex items-start gap-4 border-l-4 border-pink-500">

                            <div>
                                <h3 className="text-lg font-semibold text-pink-500">Houses in your birth chart</h3>
                                <p className="text-gray-700 text-sm mt-2">
                                    The houses in your birth chart represent different areas of life where you focus your energy and
                                    attention. They highlight the arenas where your planetary energies and sign qualities play out.
                                </p>
                            </div>
                        </div>

                        {/* Card 4 - Aspects */}
                        <div className="bg-white p-6 shadow-md rounded-lg flex items-start gap-4 border-l-4 border-blue-500">
                            <div>
                                <h3 className="text-lg font-semibold text-blue-500">Aspects formed in your birth chart</h3>
                                <p className="text-gray-700 text-sm mt-2">
                                    Aspects are the relationships and interactions between the planets in your chart. They create
                                    patterns of harmony (supporting your natural talents) or challenge (indicating areas for growth).
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Queryform />
            <Footer />

        </section>
    );
};

export default NatalChart;